<ion-header class="ion-no-border">
    <ion-toolbar>
        <ion-title>Qr Codes</ion-title>
        <ion-button (click)="generateVirtualQr()" fill="clear" slot="end" sxMargin="0 large">
            <ion-icon name="add-outline"></ion-icon>
            Create QR
        </ion-button>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div sxRow sxWidth="full" sxGap="10px" sxHeight="100%">
        <div sxCol sxWidth="fill" sxHeight="fill" sxPadding="medium" *ngIf="(allScanners$ | async)?.length > 0">
            <div id="list">
                <div sxBackground="light" sxBorderWidth="0 0 1px" sxCursor="pointer" sxBorderColor="one" sxRow
                    sxAlign="center" sxDistribution="spaceBetween" sxPadding="medium large" sxRadius="15px 15px 0 0">
                    <p sxWidth="fill">Code</p>
                    <p sxWidth="fill">Title</p>
                    <p sxWidth="fill">Created On</p>
                    <p></p>
                </div>
                <div sxRow sxAlign="center" sxDistribution="spaceBetween" sxBackground="light" sxBorderWidth="0 0 1px"
                    sxCursor="pointer" sxBorderColor="one" sxPadding="medium large" sxColor="#264F49"
                    *ngFor="let scanner of allScanners$ | async" (click)="selectedScanner(scanner)">
                    <p sxWidth="fill">{{ getUniqueCode(scanner.qr) }}</p>
                    <p sxWidth="fill">
                        {{
                        scanner.scannerTemplateOptions.length > 1
                        ? scanner.commonTitle
                        : scanner.scannerTemplateOptions[0].label
                        }}
                    </p>
                    <p sxWidth="fill">{{ scanner.createTime | date : 'medium' }}</p>
                    <ion-icon name="chevron-forward-outline" sxTextSize="large" slot="end"></ion-icon>
                </div>
            </div>
        </div>

        <div *ngIf="(allScanners$ | async)?.length < 1" sxCol sxWidth="full" sxGap="10px" sxHeight="full"
            sxAlign="center" sxDistribution="center">
            <img sxWidth="200px" src="/assets/qid-qr-stand-outline.png" alt="img" />
            <h2 sxTextAlign="center">Link a qid QR Code stand with this template</h2>
        </div>

        <div *ngIf="activeSlide" sxMaxWidth="400px" sxWidth="full" sxMaxHeight="100%" sxOverflow="hidden"
            id="sidePanel">
            <view-scanner *ngIf="activeSlide === slides.viewQr" [scanner]="currentScanner" [loading]="false"
                (closed)="close($event)" [closeButton]="true">
            </view-scanner>
            <div sxHeight="full" sxWidth="full" sxPadding="0 0 60px">
                <app-add-template-option *ngIf="activeSlide === slides.viewForms" [qrCode]="qrCode" [closeButton]="true"
                    (closed)="close($event)">
                </app-add-template-option>
            </div>
        </div>
    </div>
</ion-content>